// Vue
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// Template
import template from "./template.vue";

@Component({
  mixins: [template],
})
export default class Configuration extends Vue {
  @Prop()
  konsi!: object;

  @Prop()
  translation!: object;

  get config() {
    let groups = {};

    this.konsi["equipment"].forEach((eq) => {
      if (!groups[eq.group]) {
        groups[eq.group] = [];
      }

      groups[eq.group].push(eq);
    });

    let result: object[] = [];
    Object.keys(groups)
      .sort()
      .forEach((groupName) => {
        result.push({
          title: groupName,
          items: groups[groupName],
        });
      });

    return result;
  }
}
